<template>
  <VCard class="notification">
    <!-- Visual only: the announcement is owned by the always-rendered sr-only
         live region in NotificationProvider. Exposing this copy to AT as well
         would read the same sentence twice. -->
    <VCardText aria-hidden="true" class="font16 text-center font-weight-medium">
      {{ text }}
    </VCardText>
  </VCard>
</template>

<script setup lang="ts">
defineProps<{
    text?: string
}>()
</script>

<style lang="scss">
</style>
